import dedicatedServerImg from "public/iaas/dedicated_server.png";
import disasterRecoveryImg from "public/iaas/disaster_recovery.png";
import gpuHostingImg from "public/iaas/gpu_hosting.png";
import kubernetesImg from "public/iaas/kubernetes.png";
import vdiImg from "public/iaas/virtual_device_infrastructure.png";
import ManagedUnmanagedComanaged from "public/privateCloud/icons/managed-unmanaged-comanaged.png";
import OpenStackCloud from "public/privateCloud/icons/openstack-cloud.png";
import VMwareCloud from "public/privateCloud/icons/vmware-cloud.png";
import ZadaraCloud from "public/privateCloud/icons/zadara-cloud.png";
import CertificationLabs from "public/pocCloud/icons/certification-labs.png";
import EmulateSimulateReal from "public/pocCloud/icons/emulate-simulate-real.png";
import NetworkAutomation from "public/pocCloud/icons/network-automation.png";
import NetworkDigitalTwins from "public/pocCloud/icons/network-digital-twins.png";
import PerformanceLabs from "public/pocCloud/icons/performance-labs.png";
import PhysicalLabs from "public/pocCloud/icons/physical-labs.png";
import { ContentCard } from "@/components/contentCard";
import { MAIN_ROUTES, CLOUD_SERVICES_ROUTES } from "@/constants/routes";

export const SERVICES_CONSTANTS = {
  title: "Cloud Services by Onemind ",
  desc: "At Onemind, we offer two key cloud solutions to meet modern business needs: ",
};

export const SERVICES_TABS = {
  PRIVATE_CLOUD: "Private Cloud",
  POC_CLOUD: "POC Cloud",
};

export const PrivateCloud_CONSTANTS = {
  tabHead: "Private Cloud",
  title: "Private Cloud – Secure & Scalable Cloud Infrastructure",
  desc: "Designed for businesses that require high performance, security, and control, our Private Cloud solutions enable seamless operations across industries.",
  list: [
    {
      image: OpenStackCloud,
      title: "OneMind's Managed Open Stack(MOST)",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.OPEN_STACK_CLOUD}`}
          points={[
            "Scalable and modular architecture",
            "Seamless integration with hybrid and multi-cloud",
            "Enterprise-grade security and automation",
          ]}
        />
      ),
    },
    {
      image: ZadaraCloud,
      title: "Zadara Cloud",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.ZADARA_CLOUD}`}
          points={[
            "Pay-as-you-go pricing with no vendor lock-in",
            "Fully managed cloud infrastructure",
            "Guaranteed uptime and enterprise security",
          ]}
        />
      ),
    },
    {
      image: VMwareCloud,
      title: "VMware Cloud",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.VMWARE_CLOUD}`}
          points={[
            "Effortless migration to cloud",
            "Advanced automation for cloud-native applications",
            "Industry-leading security and compliance",
          ]}
        />
      ),
    },
    {
      image: disasterRecoveryImg,
      title: "OEM Converged Architecture",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.OEM_CONVERGED_ARCHITECTURE}`}
          points={[
            "Optimized infrastructure for OEM applications",
            "Seamless integration with existing IT systems",
            "Improved security, efficiency, and scalability",
          ]}
        />
      ),
    },
    {
      image: kubernetesImg,
      title: "Private K8 Clusters",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PRIVATE_K8_CLUSTERS}`}
          points={[
            "Network-isolated clusters for enhanced security",
            "Built-in auto-scaling and self-healing capabilities",
            "Seamless integration with hybrid cloud environments",
          ]}
        />
      ),
    },
    {
      image: gpuHostingImg,
      title: "Virtuozzo IaaS and PaaS",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.VIRTUOZZO_PAAS}`}
          points={[
            "Hyperconverged infrastructure for IaaS workloads",
            "PaaS for automated application scaling",
            "Multi-cloud & hybrid cloud-ready",
          ]}
        />
      ),
    },
    {
      image: dedicatedServerImg,
      title: "Encrypted Storage Clusters",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.ENCRYPTED_STORAGE_CLUSTERS}`}
          points={[
            "End-to-end encryption for data at rest & in transit",
            "Fault-tolerant architecture for high availability",
            "Scalable, enterprise-grade cloud storage",
          ]}
        />
      ),
    },
    {
      image: ManagedUnmanagedComanaged,
      title: "Managed, Unmanaged, Co-managed",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.MANAGED_UNMANAGED_CO_MANAGED}`}
          points={[
            "Managed: Fully outsourced IT management",
            "Unmanaged: Full control over cloud resources",
            "Co-managed: Collaboration between your team & experts",
          ]}
        />
      ),
    },
  ],
};

export const POC_Cloud_CONSTANTS = {
  tabHead: "POC Cloud",
  title: "POC Cloud – Test & Validate Innovations Before Full Deployment",
  desc: "POC (Proof-of-Concept) Cloud provides on-demand lab environments to help businesses test, evaluate, and optimize IT solutions before full-scale deployment.",
  list: [
    {
      image: vdiImg,
      title: "Lab-as-a-Service",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.LAB_AS_A_SERVICE}`}
          points={[
            "Fully managed cloud lab infrastructure",
            "On-demand scalability for experiments & training",
            "Cost-effective & real-world simulation environments",
          ]}
        />
      ),
    },
    {
      image: disasterRecoveryImg,
      title: "POC-as-a-Service",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.POC_AS_A_SERVICE}`}
          points={[
            "Real-world testing before production deployment",
            "Quickly validate performance and feasibility",
            "Eliminate costly IT infrastructure investments",
          ]}
        />
      ),
    },
    {
      image: NetworkDigitalTwins,
      title: "Network Digital Twins",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.NETWORK_DIGITAL_TWINS}`}
          points={[
            "Replicate real-world network environments",
            "Optimize configurations & security policies",
            "Predict & prevent network failures before they happen",
          ]}
        />
      ),
    },
    {
      image: CertificationLabs,
      title: "Certification Labs",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.CERTIFICATION_LABS}`}
          points={[
            "Industry-standard certification environments",
            "Fully virtualized and scalable infrastructure",
            "On-demand access for training & upskilling",
          ]}
        />
      ),
    },
    {
      image: PhysicalLabs,
      title: "Physical Labs (SI | VAR | COE)",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PHYSICAL_LABS}`}
          points={[
            "Hands-on testing & development environment",
            "Simulate real-world IT infrastructure",
            "Improve solution efficiency before deployment",
          ]}
        />
      ),
    },
    {
      image: NetworkAutomation,
      title: "Network Automation",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.NETWORK_AUTOMATION}`}
          points={[
            "Self-healing & auto-scaling network configurations",
            "AI-powered traffic optimization & monitoring",
            "Enhance security & compliance with automated policies",
          ]}
        />
      ),
    },
    {
      image: PerformanceLabs,
      title: "Performance Labs | OEM Test Labs",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PERFORMANCE_LABS}`}
          points={[
            "Replicate production environments for performance validation",
            "Fine-tune applications, networks, and hardware configurations",
            "Ensure stability & efficiency before deployment",
          ]}
        />
      ),
    },
    {
      image: EmulateSimulateReal,
      title: "Emulate | Simulate | Real",
      content: (
        <ContentCard
          link={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.EMULATE_SIMULATE_REAL}`}
          points={[
            "Emulation: Replicate real systems with software",
            "Simulation: Predict system behavior under different conditions",
            "Real-world testing: Validate deployments with actual infrastructure",
          ]}
        />
      ),
    },
  ],
};
